import React, { useState, useEffect, useCallback } from 'react'
import MyTextArea from '../../../components/MyTextArea'
import MyTitleArea from '../../../components/MyTitleArea'
import { useTranslation } from 'react-i18next'

interface UserTitleFormProps {
  formData: { title: string; description: string }
  handleFieldChange: (field: string, value: any) => void
}

const UserTitleForm: React.FC<UserTitleFormProps> = ({
  formData,
  handleFieldChange,
}) => {
  const { t } = useTranslation()

  const getStorageKey = () => {
    const currentPath = window.location.pathname
    if (currentPath === '/dashboard/announce-work/') return 'myJobOffer'
    if (currentPath === '/dashboard/announce-event/') return 'myEvent'
    if (currentPath === '/dashboard/announce-establishment/')
      return 'myEstablishment'
    return 'myAnnounce'
  }

  const storageKey = getStorageKey()

  const getLocalStorageData = () => {
    const data = localStorage.getItem(storageKey)
    return data ? JSON.parse(data) : {}
  }

  const setLocalStorageData = (key: string, value: string) => {
    const localData = getLocalStorageData()
    localData[key] = value
    localStorage.setItem(storageKey, JSON.stringify(localData))
  }

  const [title, setTitle] = useState(formData.title || '')
  const [description, setDescription] = useState(formData.description || '')

  const updateLocalStorageAndState = useCallback(() => {
    const localData = getLocalStorageData()
    const newTitle = localData.title || formData.title || ''
    const newDescription = localData.description || formData.description || ''

    if (newTitle !== title) {
      setTitle(newTitle)
      handleFieldChange('title', newTitle)
    }

    if (newDescription !== description) {
      setDescription(newDescription)
      handleFieldChange('description', newDescription)
    }
  }, [formData, handleFieldChange, title, description])

  useEffect(() => {
    updateLocalStorageAndState()
  }, [updateLocalStorageAndState])

  const handleTitleChange = (newTitle: string) => {
    setTitle(newTitle)
    setLocalStorageData('title', newTitle)
    handleFieldChange('title', newTitle)
  }

  const handleDescriptionChange = (value: string) => {
    setDescription(value)
    setLocalStorageData('description', value)
    handleFieldChange('description', value)
  }

  return (
    <div>
      <div className='bg-anthracite text-white p-2 font-semibold uppercase rounded-t-lg text-center'>
        {t('create-ad.title')}
      </div>
      <MyTitleArea
        minLines={1}
        placeholder={t('create-ad.title')}
        value={title}
        minLength={5}
        maxLength={64}
        onChange={e => handleTitleChange(e.target.value)}
        className='p-5 rounded-b-md'
      />
      <div className='bg-anthracite text-white p-2 font-semibold uppercase rounded-t-lg text-center'>
        {t('create-ad.description')}
      </div>
      <MyTextArea
        minLines={5}
        variant='grisclairBorder'
        placeholder={t('create-ad.description')}
        value={description}
        onChange={handleDescriptionChange}
        minLength={130}
        maxLength={2500}
      />
    </div>
  )
}

export default UserTitleForm
